import { useEffect } from 'react';

export const InitialSettingsHandler = () => {
  useEffect(() => {
    sessionStorage.removeItem(`refreshing`);
  }, []);

  return null;
};
